import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Chip } from 'cprime-foundational-components';

const PrintChip = ({ label, backgroundColor, color, outlined }) => {
  return (
    <Box
      display="table-cell"
      backgroundColor={backgroundColor}
      borderRadius=".25rem"
      border={outlined && '1px solid'}
      borderColor="divider"
    >
      <Chip
        label={label}
        color={color}
        backgroundColor="transparent"
        sx={{
          '& .MuiTypography-root': { fontSize: '0.5625rem' },
        }}
      />
    </Box>
  );
};

PrintChip.propTypes = {
  label: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  outlined: PropTypes.bool,
};
export default PrintChip;
